<template>
  <div class="index-box">
    <div class="page-title">当前位置：北京老科技工作者总会会员管理系统 > 通知公告</div>
    <div class="info-box">
      <div class="info-title">
        <span>通知公告</span>
      </div>
      <div class="index-notice-list">
        <div>
          <a v-for="item in list" :key="item.noticeId" :href="'/home/noticeDetail?id='+item.noticeId" class="index-notice-item">
            <span><b :class="{active:!item.readStatus}">{{item.readStatus?'已读':'未读'}}</b> <i
              class="ovDna">{{item.title}}</i></span>
            <b>{{item.createTime}}</b>
          </a>
            <div v-if="list.length === 0" style="height: 430px;padding: 100px;">
                <img src="../../assets/img/nodata.png" alt="" style="display: block;margin: 0 auto;">
                <p style="text-align: center;color: #999;">暂无数据</p>
            </div>
        </div>
        <div class="page-box" v-if="list.length > 0">
          <el-pagination
            class="page-list"
            background
            layout="prev, pager, next"
            :current-page="page"
            :page-count="totalPage"
            @current-change="postFanye"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NoticeList",
    data() {
      return {
        list:[],
        page: 1,          //  当前页数
        totalPage: 1,     //  总页数
      }
    },
    created() {
      this.$emit('setNav', 1)
      this.init()
    },
    methods:{
      init(){
        this.$api.apiContent.noticeList({
          token: this.$store.state.user.token,
          pageNum:this.page,
          pageSize:12
        }).then(res=>{
          res.row.map(item=>{
            item.createTime = this.$tools.ZHDate(new Date(item.createTime))
          })
          this.list = res.row
          this.totalPage = res.total
        })
      },
      postFanye(val){
        this.page = val
        this.init()
      },
    }
  }
</script>

<style scoped lang="scss">
  .index-box {
    .page-title {
      width: 100%;
      height: 62px;
      padding: 0 24px;
      line-height: 62px;
      background-color: #ffffff;
      margin-bottom: 10px;
    }

    .info-box {
      height: 712px;
      padding: 25px 27px;
      background: #fff;

      .info-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0 12px;
        background-image: linear-gradient(0deg,
          #2084da 0%,
          #3295e8 100%);
        border-radius: 4px;

        span {
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
        }

        a.more {
          width: 56px;
          height: 26px;
          text-align: center;
          line-height: 26px;
          font-size: 14px;
          color: #0c7cbc;
          background-color: #e9f5ff;
          border-radius: 13px;
        }
      }

      .index-notice-list {
        a.index-notice-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 55px;
          line-height: 55px;
          font-size: 20px;
          color: #333;
          border-bottom: 1px dashed #e9e9e9;

          &:last-child {
            border-bottom: 0;
          }

          span {
            display: flex;
            align-items: center;
            width: 700px;
            padding-left: 10px;
            position: relative;

            i {
              flex: 1;
            }

            b {
              display: block;
              width: 48px;
              height: 22px;
              text-align: center;
              line-height: 22px;
              background-color: #e5e5e5;
              border-radius: 11px;
              color: #fff;
              font-size: 14px;
              margin-right: 10px;

              &.active {
                background-color: #e9f5ff;
                color: #2b8ee3;
              }
            }
          }
        }

      }

      .page-box {
        display: flex;
        align-items: center;
        padding: 30px 0 0;
        .page-list {
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
</style>
